var React = require('react');

function Unhappy (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M48.563 44a6.562 6.562 0 1 0 0 13.125 6.562 6.562 0 1 0 0-13.125zm30.625 0a6.562 6.562 0 1 0 0 13.125 6.562 6.562 0 1 0 0-13.125zM75.07 87.487c-3.95-.83-7.617-1.233-11.209-1.233-3.583 0-7.254.402-11.209 1.233-4.856 1.02-8.505-1.05-9.865-4.44-3.737-9.323 6.238-17.356 21.07-17.356 15.474 0 24.788 8.107 21.074 17.36-1.348 3.365-4.97 5.465-9.861 4.436zm-11.213-8.6c7.06 0 13.37 2.93 14.026 1.22 3.513-9.096-31.509-9.472-28.048 0 .603 1.65 7.061-1.22 14.022-1.22zM64 5C31.415 5 5 31.415 5 64s26.415 59 59 59 59-26.415 59-59S96.585 5 64 5zm0 108c-27.062 0-49-21.938-49-49s21.938-49 49-49c27.048.033 48.967 21.952 49 49 0 27.062-21.938 49-49 49z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("g",{"fill":"#FFF","mask":"url(#b)","key":1},React.createElement("path",{"d":"M0 0h128v128H0z"}))])]);
}

Unhappy.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128"};

module.exports = Unhappy;

Unhappy.default = Unhappy;



// WEBPACK FOOTER //
// ./src/Assets/Icons/unhappy.svg